/* tslint:disable */
/* eslint-disable */
/**
 * EH Commissioning WebAPI 1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ChangeEmailResponse
 */
export interface ChangeEmailResponse {
  /**
   *
   * @type {string}
   * @memberof ChangeEmailResponse
   */
  currentEmail?: string | null;
  /**
   *
   * @type {string}
   * @memberof ChangeEmailResponse
   */
  newEmail?: string | null;
}

export function ChangeEmailResponseFromJSON(json: any): ChangeEmailResponse {
  return ChangeEmailResponseFromJSONTyped(json, false);
}

export function ChangeEmailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangeEmailResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    currentEmail: !exists(json, "currentEmail") ? undefined : json["currentEmail"],
    newEmail: !exists(json, "newEmail") ? undefined : json["newEmail"],
  };
}

export function ChangeEmailResponseToJSON(value?: ChangeEmailResponse | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    currentEmail: value.currentEmail,
    newEmail: value.newEmail,
  };
}
